import { Link as ReactRouterLink } from 'react-router';
import { Container, Center, Stack, Title, Anchor, Box } from '@mantine/core';
import routes from '@commons/routes';
import { useTheme } from '@components/ThemeSwitch';
import { LogoSVG } from '@components/Logo/Logo';
import { useUser } from '@contexts/UserContext';

export const Root = () => {
  const animations = ['pulse-animation', 'shake-me', 'skew-animate'];
  const randomAnimation =
    animations[Math.floor(Math.random() * animations.length)];
  const { computedColorScheme } = useTheme();
  const { user } = useUser();

  return (
    <Container size={900}>
      <Center h="100svh">
        <Stack align="center" gap="md">
          <Box className={randomAnimation}>
            <LogoSVG height={35} theme={computedColorScheme} />
          </Box>

          <Title order={3}>Cauți un contract?</Title>

          <Anchor
            component={ReactRouterLink}
            to={routes.routes.access}
            size="sm"
            c="blue"
            underline="never"
          >
            Click aici
          </Anchor>

          {user && (
            <Anchor
              component={ReactRouterLink}
              to={routes.routes.dashboard(user.username)}
              size="sm"
              c="blue"
              underline="never"
            >
              Ești admin?
            </Anchor>
          )}
        </Stack>
      </Center>
    </Container>
  );
};
